﻿import React, { useState, useEffect, useRef } from "react";
import { useSignal, useSlot } from 'react-signal-slot'
import Popup from "../../../Popups/Popup";
import Loading from "../../../Ui/Loading";
import Input from "../../../FormUi/Input";
import AccountInfo from "../../../Profile/AccountInfo";

// данный интерфейс обеспечивает передачу некоторых данных в компонент.
interface IPropsType {
    lotId:      number,     // идентификатор лота
    StepInfo:   string,     // информаци о шаге аукциона
    MinimumBet: number,     // сумма минимальной ставка в рублях
    CompanyId: number,      // id того кто поставил последнюю ставку
    lot: any,
}

// данный комопнент реализует кнопку "Сделать ставку". Он отображает её и отвечает за её логику работы.
function MakeBet(props: IPropsType) {

    const [isOpen, setIsOpen] = useState(false);
    const [popupHead, setPopupHead] =
        useState<{ title: string, description?: string }>({ title: "Сделать ставку", description: props.StepInfo })
    const [isLoading, setIsLoading] = useState(false);
    const [isFinally, setIsFinally] = useState(false);

    const [isCanMakeBet, setIsCanMakeBet] = useState()

    const [step, setStep] = useState(0);
    const [error, setError] = useState('');
    const betValue = useRef();

    const signalMakeBet = useSignal();

    // метод валидации ставки сделаной пользовтелем
    const makeBetHandle = () => {
        if (props.lot.StepValue) {
            return makeBet(props.lot.CurrentPrice + props.lot.StepValue);
        }

        if (props.lot.StepPercent) {
            return makeBet(props.lot.CurrentPrice + (props.lot.CurrentPrice * props.lot.StepPercent / 100));
        }

        if (betValue.current && Number(betValue.current) >= props.MinimumBet) {
            return makeBet(betValue.current);
        } else {
            return setError('Ставка не может быть меньше ' + props.MinimumBet.toString())
        }
    }

    //Сделать ставку
    const makeBet = async (value) => {
        setIsLoading(true);
        try {
            const response = await fetch("/Bidding/MakeBet", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    BidAmount: parseFloat(value),
                    TradeLotId: props.lotId,
                }),
            });

            const data = await response.json();
            if (!data.Success) {
                console.log('MakeBet', data.Error);
                setIsFinally(true);
                setIsLoading(false);
                setPopupHead({ title: "Произошла ошибка", description: data.Error })
            } else {
                console.log("Ставка сделана!");
                setIsFinally(true);
                setIsLoading(false);
                setPopupHead({ title: "Ставка успешно сделана!" })
                signalMakeBet('makeBet', value);
            }
        } catch (error) {
            setIsFinally(true);
            setIsLoading(false);
            setPopupHead({ title: "Произошла ошибка" })
            if (error.response && error.response.status === 401) {
                window.location.href = `/Account/Login?ReturnUrl=${encodeURIComponent(window.location.pathname)}`;
            }
        }
    }

    const renderBody = () => {
        if (props.lot.StepValue) {
            return <p className="defaultDescription">Ваша ставка составит {props.lot.CurrentPrice + props.lot.StepValue} рублей</p>;
        }

        if (props.lot.StepPercent) {
            return <p className="defaultDescription">Ваша ставка составит {props.lot.CurrentPrice + (props.lot.CurrentPrice * props.lot.StepPercent / 100)} рублей</p>;
        }

        return (
            <Input
                field={{ name: "bet", title: "Ставка:" }}
                onChange={(n, value) => betValue.current = value}
                error={error}
            />
        );
    }

    const close = () => {
        setIsOpen(false);
        setIsFinally(false);
        setError("");
        setPopupHead({ title: "Сделать ставку", description: props.StepInfo })
    }

        return (
            <React.Fragment>
                {AccountInfo.CompanyId === props.CompanyId ?
                    <div className="infoItem defaultDescription">Вы уже сделали ставку. Ваша ставка максимальная. В следующий раз можно будет сделать ставку когда ваша ставка будет перебита другим участником.</div>
                    :
                    <button className="defaultPinkButton" onClick={() => { setIsOpen(true) }}>Сделать ставку</button>
                }

                <Popup
                    isOpen={isOpen}
                    head={popupHead}
                    close={close}
                    isFinally={isFinally}
                    loading={isLoading}
                    body={renderBody()}
                    actionButtons={[{ name: "Подтвердить", action: makeBetHandle }]}
                />
            </React.Fragment>
        )
    }



export default MakeBet;